import styled from 'styled-components';

export const SubmitButtonContainer = styled.div`
  padding: 10px 0;
`;

export const TextContainer = styled.div`
  padding: 10px 15px;
  text-align: center;
`;

export const Body = styled.div`
  padding: 15px 0;
`;

export const DescriptionHeader = styled.div`
  display: flex;
  margin-bottom: 15px;
  justify-content: space-between;
`;

export const Item = styled.div`
  margin: 0 -15px;
  padding: 0 15px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
`;
